import React, { FC } from "react";
import { useAppSelector } from '@/app/lib/hooks';
import { RootState } from '@/app/lib/store';
import { useTranslation } from "react-i18next";

export interface Recruitment7Props {}

const Recruitment7: FC<Recruitment7Props> = () => {
  const { t } = useTranslation("guydeez");
  const u = useAppSelector((state: RootState) => state.auth.user);

  return (
    <div className="flex flex-col items-center text-center" style={{ padding: "8px 0" }}>
      {/* Success badge */}
      <span
        className="grid place-items-center"
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          background: "rgba(31,122,69,.12)",
          marginBottom: 20,
        }}
        aria-hidden="true"
      >
        <span
          className="grid place-items-center"
          style={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: "var(--g-green-ada, #1F7A45)",
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>
      </span>

      <h2 style={{ fontSize: 22, fontWeight: 800, color: "var(--g-burgundy)", lineHeight: 1.2, marginBottom: 6 }}>
        {t('recruitment_mail_sent_title')}
      </h2>
      <p style={{ fontSize: 14, color: "var(--g-ink-500)", marginBottom: 16 }}>
        {t('recruitment_mail_sent_subtitle')}
      </p>
      <p style={{ fontSize: 15, fontWeight: 700, color: "var(--g-ink-900, #1a1a1a)", marginBottom: 20 }}>
        {t('recruitment_thank_you_name', { firstName: u?.firstName, lastName: u?.lastName })}
      </p>

      {/* Confirmation card */}
      <div
        className="flex items-start"
        style={{
          gap: 12,
          maxWidth: 440,
          width: "100%",
          textAlign: "left",
          padding: 16,
          borderRadius: 14,
          background: "rgba(31,138,91,.06)",
          border: "1px solid rgba(31,138,91,.2)",
        }}
      >
        <span
          className="grid place-items-center"
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: "var(--g-green-deep, #2E8C4D)",
            flexShrink: 0,
          }}
          aria-hidden="true"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="m3 7 9 6 9-6" />
          </svg>
        </span>
        <p
          style={{
            fontSize: 13,
            color: "var(--g-ink-700, #4a4a4a)",
            lineHeight: 1.5,
            wordBreak: "break-word",
            minWidth: 0,
          }}
        >
          {t('recruitment_confirmation_email_sent', { email: u?.email })}
        </p>
      </div>
    </div>
  );
};

export default Recruitment7;
